var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6, 6) scale(1.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.18 10.14C2.82667 10.14 1.79067 9.79 1.072 9.09C0.362667 8.38067 0.00800006 7.33533 0.00800006 5.954V0.129999H1.8V5.94C1.8 6.82667 2.00067 7.494 2.402 7.942C2.81267 8.38067 3.40533 8.6 4.18 8.6C4.95467 8.6 5.54267 8.38067 5.944 7.942C6.34533 7.494 6.546 6.82667 6.546 5.94V0.129999H8.324V5.954C8.324 7.33533 7.974 8.38067 7.274 9.09C6.574 9.79 5.54267 10.14 4.18 10.14Z",
    fill: "#003D50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/Unknown.812be2eca74615408b7429661b6a1d0c.svg";
export { ForwardRef as ReactComponent };